//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { CarritoState } from "@/typings/store/plugins/easyFirestore/carritos";

const getters: GetterTree<CarritoState, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const carritos = {
    firestorePath: "dev/v1/carritos",
    firestoreRefType: "collection",
    moduleName: "carritos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default carritos;
